import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Canvas } from "@react-three/fiber";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 44, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "112%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.15, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function SectionTag({ number, label }) {
  return (
    <div className="flex items-center gap-4 mb-6" data-testid={`section-tag-${number || label}`}>
      {number && (
        <>
          <span className="font-outfit text-xs tracking-[0.4em] text-gold">{number}</span>
          <span className="h-px w-10 bg-gold/40" />
        </>
      )}
      <span className="text-[11px] tracking-[0.35em] uppercase text-white/50">{label}</span>
    </div>
  );
}

export function scrollToId(id) {
  const target = document.getElementById(id);
  if (!target) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -72, duration: 1.5 });
  } else {
    target.scrollIntoView({ behavior: "smooth" });
  }
}

export function CanvasInView({ children, className = "", camera, dpr = [1, 1.75], ...rest }) {
  const ref = useRef(null);
  const inView = useInView(ref, { margin: "240px" });
  return (
    <div ref={ref} className={className}>
      {inView ? (
        <Canvas camera={camera} dpr={dpr} gl={{ antialias: true, alpha: true, powerPreference: "high-performance" }} {...rest}>
          {children}
        </Canvas>
      ) : null}
    </div>
  );
}
